<template>
  <v-tooltip color="tooltip" :disabled="!tooltip" bottom>
    <template #activator="{ on }">
      <v-hover #default="{ hover }" :disabled="disabled">
        <span v-on="on">
          <v-btn
            v-bind="{ ...buttonBind }"
            v-on="$listeners"
            :class="{ 'elevation-4': hover, 'mobile-map-button-shadow': shadow }"
          >
            <v-icon :size="iconSize" :color="iconColor"> {{ icon }} </v-icon>
            <template #loader>
              <main-loader :size="loaderSize" :color="loaderColor" />
            </template>
          </v-btn>
        </span>
      </v-hover>
    </template>
    {{ $i18n.t(tooltip) }}
  </v-tooltip>
</template>

<script>
import MainLoader from '@/components/shared/MainLoader';

export default {
  name: 'BaseRoundedButton',
  components: { MainLoader },
  props: {
    size: {
      type: String,
      default: 'small',
    },
    color: {
      type: String,
      default: 'secondary',
    },
    icon: {
      type: String,
      default: '',
    },
    iconSize: {
      type: String,
    },
    iconColor: {
      type: String,
      default: '#fff',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    loaderSize: {
      type: Number,
      default: 24,
    },
    loaderColor: {
      type: String,
      default: '#fff',
    },
    tooltip: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    shadow: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    buttonBind() {
      return {
        [this.size]: true,
        color: this.color,
        loading: this.loading,
        disabled: this.disabled,
        ripple: false,
        depressed: true,
        fab: true,
      };
    },
  },
};
</script>
